import {LeadEventApiDto, LeadQuoteFilesAttachedEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");

export default class LeadQuoteFilesAttachedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param data lead quote files attached files event data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadQuoteFilesAttachedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadQuoteFilesAttachedEvent {
		const data = LeadQuoteFilesAttachedEventData.fromJson(json.data as LeadQuoteFilesAttachedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadQuoteFilesAttachedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteFilesAttached,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.attachments;
	}

	getActivityType(): string {
		return `QUOTE ${this.data.quoteNumber}${this.data.versionNumber > 1 ? ` v${this.data.versionNumber}` : ""}`
	}

	getActivityMessage(): string {
		return "Files added";
	}

	getActivityAdditionalMessages(): string[] {
		return [this.data.jobTypeName]
	}
}

export class LeadQuoteFilesAttachedEventData {
	constructor(public readonly quoteId: string,
		public readonly quoteNumber: number,
		public readonly attachments: Attachment[],
		public readonly jobTypeName: string,
		public readonly jobTypeId: string,
		public readonly versionNumber: number) {}

	public static fromJson(json: LeadQuoteFilesAttachedEventDataApiDto): LeadQuoteFilesAttachedEventData {
		return new LeadQuoteFilesAttachedEventData(json.id, json.quoteNumber, json.attachments.map(Attachment.fromJson),
			json.jobTypeName, json.jobTypeId, json.versionNumber);
	}
}
